import axios from "axios";
import { getApiBaseUrl } from "./getApiBaseUrl";
import { ngrokSkipBrowserWarningHeaders } from "./ngrokDevHeaders";

/**
 * Reîmprospătare acces (cookie refresh) — izolată pentru a putea testa
 * interceptarea 401 fără dublură de modul `axios` în Vitest.
 */
export async function tryRefreshAccessToken(): Promise<boolean> {
  try {
    const base = getApiBaseUrl();
    const refreshUrl =
      base === "" ? "/api/v1/auth/refresh" : `${base}/api/v1/auth/refresh`;
    await axios.post(refreshUrl, null, {
      withCredentials: true,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        ...ngrokSkipBrowserWarningHeaders(),
      },
    });
    return true;
  } catch {
    return false;
  }
}
